"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ddLog = exports.ddInit = void 0;
var _browserLogs = require("@datadog/browser-logs");
const DEFAULT_APP_ID = 'cvg_react_logger';
const DEFAULT_FORWARD = true;
const DEFAULT_RATE = 100;
const DEFAULT_SITE = 'datadoghq.com';
const DEFAULT_TOKEN = 'pubaeb508ee6ca1f52d8800fd9cf700bd1b';
const ddInit = _ref => {
  let {
    appId = DEFAULT_APP_ID,
    clientToken = DEFAULT_TOKEN,
    forwardErrorsToLogs = DEFAULT_FORWARD,
    sampleRate = DEFAULT_RATE,
    site = DEFAULT_SITE
  } = _ref;
  _browserLogs.datadogLogs.init({
    clientToken,
    forwardErrorsToLogs,
    sampleRate,
    service: appId,
    silentMultipleInit: true,
    site
  });
};
exports.ddInit = ddInit;
const ddLog = function (message) {
  let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let status = arguments.length > 2 ? arguments[2] : undefined;
  const formattedContext = {};
  for (const [key, value] of Object.entries(context)) {
    switch (Object.prototype.toString.call(value)) {
      case '[object Error]':
        formattedContext[key] = `${value.name}: ${value.message}`;
        break;
      case '[object ErrorEvent]':
        formattedContext[key] = `${value.type}: ${value.message}`;
        break;
      case '[object Event]':
        formattedContext[key] = `type: ${value.type}`;
        break;
      default:
        formattedContext[key] = value;
    }
  }
  _browserLogs.datadogLogs.logger.log(message, {
    'Custom_Log_Context': formattedContext
  }, status);
};
exports.ddLog = ddLog;